// db connection

import { ProductController } from 'controllers';

export const getProduct = async (barcode) => {
    return await ProductController.getBarcodeOnly(barcode);
}
